import { useNavigate } from '@tanstack/react-router'
import { AddButton } from 'components/CantileverButton'
import CantileverCard from 'components/CantileverCard'
import { generateEntrySlug } from 'features/rolodex'
import React from 'react'
import styled from 'styled-components'
import { RolodexEntryType } from 'types'

import { DetectionConfigurationTable } from './DetectionConfigurationTable'

const TableContainer = styled.div`
  margin: 1rem 0.5rem;
`

interface DetectionConfigurationCardProps {
  siteID: string
}

export const DetectionConfigurationCard: React.FC<
  DetectionConfigurationCardProps
> = ({ siteID }) => {
  const navigate = useNavigate()

  const handleCreateNewConfiguration = () => {
    navigate({
      to: '/anomaly-detection/$siteID/$detectionConfigurationId',
      params: {
        siteID,
        detectionConfigurationId: generateEntrySlug(
          RolodexEntryType.DETECTION_CONFIGURATION
        ),
      },
    })
  }

  return (
    <CantileverCard>
      <CantileverCard.CardHeader
        leadingContent='Detection Configurations'
        trailingContent={
          <AddButton
            entityName='Detection Configuration'
            onClick={handleCreateNewConfiguration}
          />
        }
      />
      <CantileverCard.Section>
        <TableContainer>
          <DetectionConfigurationTable siteID={siteID} />
        </TableContainer>
      </CantileverCard.Section>
    </CantileverCard>
  )
}
